function getNestedValue(obj: any, path: string) {
  if (!path) return "";
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

export const removeEmptyFields = <T extends Record<string, unknown>>(
  obj: T
): Partial<T> => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([, value]) => value !== null && value !== undefined && value !== ""
    )
  ) as Partial<T>;
};
export const objUtility = { getNestedValue, removeEmptyFields };
